import React from 'react';
import { Chip } from '@milanote/roma';

import { ELEMENT_LABEL_CHIP_MAX_LENGTH } from '../hooks/useLabelElementChipCallbacks';
import { getChipClassNames } from './elementChipClassNames';
import type { ElementChipProps } from './elementChipTypes';

/**
 * Renders a label pill for the generic element pills path.
 */
const LabelChip: React.FC<Extract<ElementChipProps, { type: 'label' }>> = ({
    label,
    size,
    isSelected,
    isEditing,
    canModify,
    isSearchHighlighted,
    onEditingChange,
    onEmptyBackspace,
    onCommitEdit,
    onCancelEdit,
}) => (
    <Chip
        editable
        dataChipId={label._id}
        className={getChipClassNames(isSelected, Boolean(isSearchHighlighted))}
        isDisabled={!canModify}
        value={label.name}
        color={label.color}
        size={size}
        maxLength={ELEMENT_LABEL_CHIP_MAX_LENGTH}
        isEditing={isEditing}
        onEditingChange={onEditingChange}
        onEmptyBackspace={onEmptyBackspace}
        onCancel={onCancelEdit}
        onCommit={onCommitEdit}
    />
);

export default LabelChip;
